/**
 * Password validation helpers extracted from useNewPassword.
 * Pure functions — no React dependencies.
 */

export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 64;

export const hasUppercase = (v) => /[A-Z]/.test(v);
export const hasLowercase = (v) => /[a-z]/.test(v);
export const hasDigit = (v) => /[0-9]/.test(v);
export const hasSymbol = (v) =>
  // eslint-disable-next-line no-useless-escape
  /[!@#$%^&*()_\-+=\{\}\[\]:;"'<>,\.?\/\\|~]/.test(v);

export const hasRequiredCharMix = (v) =>
  hasUppercase(v) && hasLowercase(v) && hasDigit(v) && hasSymbol(v);

export const isCommonWeakPattern = (v) => {
  const lower = v.toLowerCase();
  if (/(.)\1{7,}/.test(v)) return true;
  if (/password/.test(lower)) return true;
  if (/123456789/.test(v) || /0123456789/.test(v)) return true;
  if (/qwerty/.test(lower) || /asdfgh/.test(lower) || /abcdef/.test(lower))
    return true;
  return false;
};

export const containsEmail = (v, email) => {
  if (!email) return false;
  return v.toLowerCase().includes(email.toLowerCase());
};
